import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const contractEnvelopeSignableTypeOptions = [
  { label: 'Rep. Legal Tcard', value: 'contractee' },
  { label: 'Rep. Legal Empresa', value: 'contractor' },
  { label: 'Fiador', value: 'surety' },
  { label: 'Testemunha', value: 'witness' },
]

export const contractEnvelopeSignableTypeStrategy = optionsToStrategy(contractEnvelopeSignableTypeOptions)
